<script>
import Signature from '@wielink-application/shared/vue/components/form/horizontal/signature.vue'

export default Signature;
</script>